import { jsx as t, Fragment as p } from "react/jsx-runtime";
import { useState as C, useEffect as f } from "react";
const b = ({
  manager: s,
  removeItem: o,
  componentMap: u
}) => {
  const [c, a] = C([]);
  f(() => {
    const n = (e) => {
      a(e);
    };
    return s.subscribe(n), () => {
      s.unsubscribe(n);
    };
  }, [s]);
  const l = async (n, e) => {
    var r;
    if (!e)
      return n.onOpenChange && await n.onOpenChange(e) ? void 0 : o(n.id);
    await ((r = n.onOpenChange) == null ? void 0 : r.call(n, e));
  };
  return /* @__PURE__ */ t(p, { children: c.map((n) => {
    const e = u[n.type];
    return e ? /* @__PURE__ */ t(
      e,
      {
        ...n,
        onOpenChange: (r) => l(n, r)
      },
      n.id
    ) : null;
  }) });
};
export {
  b as DynamicContainer
};
//# sourceMappingURL=index.es499.js.map
